import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { SignedEditionBlockchainCertListStore } from "../../store/SignedEditionBlockchainCertListStore";

type SignedEditionBlockchainCertListDialogsProps = {
  store: SignedEditionBlockchainCertListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de SignedEditionBlockchainCert.
 * Separado para mantener SignedEditionBlockchainCertListPage más limpio.
 */
export const SignedEditionBlockchainCertListDialogs: React.FC<SignedEditionBlockchainCertListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
